import { apiClient } from '../utils/api-client';
import type { GalleryImage } from '../types/location-images';

class LocationImagesService {
  async addGalleryImage(locationId: string, signedId: string): Promise<GalleryImage> {
    const response = await apiClient.post(`/api/locations/${locationId}/gallery_images`, {
      signed_id: signedId,
    });
    if (!response.ok) {
      throw new Error('Failed to add gallery image');
    }
    const data = await response.json();
    return data.data as GalleryImage;
  }

  async deleteGalleryImage(locationId: string, imageId: string): Promise<void> {
    const response = await apiClient.delete(`/api/locations/${locationId}/gallery_images/${imageId}`);
    if (!response.ok) {
      throw new Error('Failed to delete gallery image');
    }
  }

  async setAsCover(locationId: string, imageId: string): Promise<{ cover_image_url: string }> {
    const response = await apiClient.post(
      `/api/locations/${locationId}/gallery_images/${imageId}/set_cover`,
      {}
    );
    if (!response.ok) {
      throw new Error('Failed to set cover image');
    }
    const data = await response.json();
    return data.data as { cover_image_url: string };
  }

  async updateLogo(
    locationId: string,
    signedId: string
  ): Promise<{ logo_url: string; logo_small_url: string }> {
    const response = await apiClient.patch(`/api/locations/${locationId}/logo`, {
      signed_id: signedId,
    });
    if (!response.ok) {
      throw new Error('Failed to update logo');
    }
    const data = await response.json();
    return data.data as { logo_url: string; logo_small_url: string };
  }

  async updateProfile(
    locationId: string,
    attrs: { name?: string; bio?: string }
  ): Promise<{ name: string; bio?: string }> {
    const response = await apiClient.patch(`/api/locations/${locationId}/profile`, attrs);
    if (!response.ok) {
      throw new Error('Failed to update profile');
    }
    const data = await response.json();
    return data.data as { name: string; bio?: string };
  }
}

export const locationImagesService = new LocationImagesService();
